import { render, staticRenderFns } from "./virtualGoodsEdit.vue?vue&type=template&id=1ad9abe7&scoped=true&"
import script from "./virtualGoodsEdit.vue?vue&type=script&lang=ts&"
export * from "./virtualGoodsEdit.vue?vue&type=script&lang=ts&"
import style0 from "./virtualGoodsEdit.vue?vue&type=style&index=0&id=1ad9abe7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad9abe7",
  null
  
)

export default component.exports